exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.stop[data-v-1ba114ff]{text-align:center;margin-top:3.52rem\n}\n.stop img[data-v-1ba114ff]{width:2.67rem;height:2.67rem;margin-bottom:.43rem\n}\n.stop p[data-v-1ba114ff]{font-size:.43rem;color:#323235;line-height:.43rem\n}", ""]);

// exports
